import store from "@/store";
import i18n from "@/lang";
import router from "@/router";
import Vue from 'vue'

function createTranslationMap(messages, prefix = '', result = new Map()) {
  Object.keys(messages || {}).forEach(key => {
    const value = messages[key]
    const path = prefix ? `${prefix}.${key}` : key
    if (value && typeof value === 'object') {
      createTranslationMap(value, path, result)
    } else if (typeof value === 'string' && !result.has(value)) {
      result.set(value, path)
    }
  })
  return result
}

export function syncRouteTitles(previousLanguage, language) {
  const menus = store.state.user.menus || []
  const previousMessages = i18n.getLocaleMessage(previousLanguage)
  const translationMap = createTranslationMap(previousMessages)

  const updateRoutes = routeList => {
    routeList.forEach(route => {
      if (route.meta && route.meta.title) {
        const menu = menus.find(item => item.name === route.name)
        if (menu) {
          Vue.set(route.meta, 'title', language === 'zh'
            ? menu.managerTitle || menu.title
            : menu.managerTitleEn || menu.title)
        } else {
          const titleKey = route.meta.i18nTitleKey || translationMap.get(route.meta.title)
          if (titleKey) {
            Vue.set(route.meta, 'i18nTitleKey', titleKey)
            Vue.set(route.meta, 'title', i18n.t(titleKey))
          }
        }
      }
      if (Array.isArray(route.children)) updateRoutes(route.children)
    })
  }

  updateRoutes(store.getters.routers || [])

  const breadcrumbParent = store.getters.breadcrumbParent
  if (breadcrumbParent && breadcrumbParent.name) {
    const resolvedParent = router.resolve({name: breadcrumbParent.name}).route
    store.commit('SET_BREADCRUMB_PARENT', Object.assign({}, breadcrumbParent, {
      title: resolvedParent.meta && resolvedParent.meta.title
        ? resolvedParent.meta.title
        : breadcrumbParent.title
    }))
  }
}



// WEBPACK FOOTER //
// ./src/utils/settingRouteLang.js